// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nestedTable__PaE6s {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
  box-shadow: var(--table-box-shadow);
}
.nestedTable__PaE6s th {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 15px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: left;
  text-wrap: nowrap;
  position: sticky;
  top: 96px;
  z-index: 0;
}
.nestedTable__PaE6s th:first-child {
  width: 450px;
  padding-left: 36px;
}
@media (max-width: 1000px) {
  .nestedTable__PaE6s th {
    padding: 10px 10px;
  }
  .nestedTable__PaE6s th:first-child {
    width: 300px;
    padding-left: 16px;
  }
}
@media (max-width: 850px) {
  .nestedTable__PaE6s th:first-child {
    width: 250px;
  }
}
.nestedTable__PaE6s td {
  font-size: 14px;
  line-height: 14px;
  padding: 18px 25px;
  color: var(--tables-primary-row-text-main);
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  transition: all 150ms ease-in-out;
}
.nestedTable__PaE6s td:first-child {
  padding-left: 36px;
}
@media (max-width: 1000px) {
  .nestedTable__PaE6s td {
    padding: 8px 10px;
  }
  .nestedTable__PaE6s td:first-child {
    padding-left: 16px;
  }
}

.showFull__l3SRS {
  display: none;
}
@media (min-width: 1000px) {
  .showFull__l3SRS {
    display: table-cell;
  }
}

.showTablet__qD5PJ {
  display: table-cell;
}
@media (min-width: 1000px) {
  .showTablet__qD5PJ {
    display: none;
  }
}

.languageName__TVRt4 {
  color: var(--tables-primary-row-text-additional);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageFacility/components/NestedTableFacilityGroup/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;AAzEF;AA2EE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AAzEJ;AA2EI;EACE,YAAA;EACA,kBAAA;AAzEN;AA4EI;EApBF;IA0BI,kBAAA;EA9EJ;EAyEI;IACE,YAAA;IACA,kBAAA;EAvEN;AACF;AA4EI;EACE;IACE,YAAA;EA1EN;AACF;AA8EE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yDAAA;EACA,qDAAA;EACA,iCAAA;AA5EJ;AA8EI;EACE,kBAAA;AA5EN;AA+EI;EAbF;IAiBI,iBAAA;EA/EJ;EA4EI;IACE,kBAAA;EA1EN;AACF;;AAgFA;EACE,aAAA;AA7EF;AA+EE;EAHF;IAII,mBAAA;EA5EF;AACF;;AA+EA;EACE,mBAAA;AA5EF;AA8EE;EAHF;IAII,aAAA;EA3EF;AACF;;AA8EA;EACE,gDAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.nestedTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n  box-shadow: var(--table-box-shadow);\n\n  th {\n    font-size: 11px;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 15px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: left;\n    text-wrap: nowrap;\n    position: sticky;\n    top: 96px;\n    z-index: 0;\n\n    &:first-child {\n      width: 450px;\n      padding-left: 36px;\n    }\n\n    @media (max-width: 1000px) {\n      &:first-child {\n        width: 300px;\n        padding-left: 16px;\n      }\n\n      padding: 10px 10px;\n    }\n\n    @media (max-width: 850px) {\n      &:first-child {\n        width: 250px;\n      }\n    }\n  }\n\n  td {\n    font-size: 14px;\n    line-height: 14px;\n    padding: 18px 25px;\n    color: var(--tables-primary-row-text-main);\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    background: var(--tables-primary-row-surface-default);\n    transition: all 150ms ease-in-out;\n\n    &:first-child {\n      padding-left: 36px;\n    }\n\n    @media (max-width: 1000px) {\n      &:first-child {\n        padding-left: 16px;\n      }\n      padding: 8px 10px;\n    }\n  }\n}\n\n.showFull {\n  display: none;\n\n  @media (min-width: 1000px) {\n    display: table-cell;\n  }\n}\n\n.showTablet {\n  display: table-cell;\n\n  @media (min-width: 1000px) {\n    display: none;\n  }\n}\n\n.languageName {\n  color: var(--tables-primary-row-text-additional);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nestedTable": `nestedTable__PaE6s`,
	"showFull": `showFull__l3SRS`,
	"showTablet": `showTablet__qD5PJ`,
	"languageName": `languageName__TVRt4`
};
module.exports = ___CSS_LOADER_EXPORT___;
